import ViewYardApp from '@/views/yard-app/ViewYardApp.vue'
import ViewStockItems from '@/views/yard-app/ViewStockItems.vue'
import ViewStockItemDetail from '@/views/yard-app/ViewStockItemDetail.vue'
import ViewPickItems from '@/views/yard-app/ViewPickItems.vue'
import ViewPickItemDetail from '@/views/yard-app/ViewPickItemDetail.vue'

import ViewLoadItems from '@/views/yard-app/ViewLoadItems.vue'
import ViewLoadItemDetail from '@/views/yard-app/ViewLoadItemDetail.vue'
import ViewCollectionItemDetail from '@/views/yard-app/ViewCollectionItemDetail.vue'
import ViewCollectionItems from '@/views/yard-app/ViewCollectionItems.vue'
import ViewCompletedLoadItems from '@/views/yard-app/ViewCompletedLoadItems.vue'

export default [
	{
		path: '/yard-app',
		name: 'yard-app-dashboard',
		component: ViewYardApp,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/stock-items',
		name: 'yard-app-stock-items',
		component: ViewStockItems,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/stock-item/:id(.*)',
		name: 'yard-app-stock-item',
		component: ViewStockItemDetail,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/pick-items',
		name: 'yard-app-pick-items',
		component: ViewPickItems,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/pick-item/:id(.*)',
		name: 'yard-app-pick-item',
		component: ViewPickItemDetail,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/load-items',
		name: 'yard-app-load-items',
		component: ViewLoadItems,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/load-item/:id(.*)',
		name: 'yard-app-load-item',
		component: ViewLoadItemDetail,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/completed-load-items',
		name: 'yard-app-completed-load-items',
		component: ViewCompletedLoadItems,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},
	{
		path: '/yard-app/collection-items',
		name: 'yard-app-collect-items',
		component: ViewCollectionItems,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	},

	{
		path: '/yard-app/collection-item/:id(.*)',
		name: 'yard-app-collect-item',
		component: ViewCollectionItemDetail,
		meta: {
			group: 'yard-app',
			navigation: true,
			permissions: ['view-yard-app']
		}
	}
]
